/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export * as extensions from "./extensions";
export { ERC20Upgradeable__factory } from "./ERC20Upgradeable__factory";
export { IERC20Upgradeable__factory } from "./IERC20Upgradeable__factory";
